import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import utilityServices from './UtilityServices';
import { toast } from 'react-toastify';
import { Satellite } from '@mui/icons-material';
const initialState = {
	utility: [],
	search: null,
	singleUtility: null,
	isSuccess: false,
	isError: false,
	isLodaing: false,
	isSingleLodaing: false,
	isSingleSuccess: false,
	massage: '',
};

export const getAllUtility = createAsyncThunk(
	'utility/all',
	async (_, thunkAPI) => {
		try {
			const token = thunkAPI.getState().auth.mainUser.data.token;
			return await utilityServices.getAllUtility(token);
		} catch (error) {
			const massage = error.message;
			return thunkAPI.rejectWithValue(massage);
		}
	},
);
// Search utility
export const searchUtility = createAsyncThunk(
	'utility/search',
	async (data, thunkAPI) => {
		try {
			const token = thunkAPI.getState().auth.mainUser.data.token;
			return await utilityServices.searchUtility(data, token);
		} catch (error) {
			const message = error.message;
			return thunkAPI.rejectWithValue(message);
		}
	},
);

//POST NEW UTILITY
export const postNewUtility = createAsyncThunk(
	'utility/post',
	async (data, thunkAPI) => {
		try {
			const token = thunkAPI.getState().auth.mainUser.data.token;
			return await utilityServices.postNewUtility(data, token);
		} catch (error) {
			const massage = error.message;
			return thunkAPI.rejectWithValue(massage);
		}
	},
);

// DELETE UTILITY
export const DeleteUtility = createAsyncThunk(
	'utility/delete',
	async (id, thunkAPI) => {
		try {
			const token = thunkAPI.getState().auth.mainUser.data.token;
			return await utilityServices.deleteUtility(id, token);
		} catch (error) {
			const massage = error.message;
			return thunkAPI.rejectWithValue(massage);
		}
	},
);

// EDIT UTILITY POVIDERS
export const editUtility = createAsyncThunk(
	'utility/edit',
	async (data, thunkAPI) => {
		try {
			const token = thunkAPI.getState().auth.mainUser.data.token;
			return await utilityServices.editUtility(data, token);
		} catch (error) {
			const massage = error.message;
			return thunkAPI.rejectWithValue(massage);
		}
	},
);

// EDIT UTILITY POVIDERS
export const getSingleUtility = createAsyncThunk(
	'utility/single',
	async (id, thunkAPI) => {
		try {
			const token = thunkAPI.getState().auth.mainUser.data.token;
			return await utilityServices.getSingleUtility(id, token);
		} catch (error) {
			const massage = error.message;
			return thunkAPI.rejectWithValue(massage);
		}
	},
);
export const utilitySLice = createSlice({
	name: 'utility',
	initialState,
	reducers: {
		reset: (state) => {
			state.isError = false;
			state.isSuccess = false;
			state.isLodaing = false;
			state.isSingleSuccess = false;
			state.massage = '';
		},
		utilitySearchAction: (state, action) => {
			state.searct = action.payload;
		},
	},
	extraReducers: {
		//get All Utility
		[getAllUtility.pending]: (state) => {
			state.isLodaing = true;
		},
		[getAllUtility.fulfilled]: (state, action) => {
			state.isLodaing = false;
			state.utility = action.payload;
			state.isSuccess = true;
		},
		[getAllUtility.rejected]: (state, action) => {
			state.isLodaing = false;
			state.isError = true;
			state.massage = action.payload;
		},

		[searchUtility.pending]: (state) => {
			state.isLodaing = true;
		},
		[searchUtility.fulfilled]: (state, action) => {
			state.isLodaing = false;
			state.utility = action.payload;
			state.isSuccess = true;
		},
		[searchUtility.rejected]: (state, action) => {
			state.isLodaing = false;
			state.isError = true;
			state.message = action.payload;
		},

		//POST NEW UTILITY
		[postNewUtility.pending]: (state) => {
			state.isLodaing = true;
		},
		[postNewUtility.fulfilled]: (state, action) => {
			state.isLodaing = false;
			state.utility.data.data.push(action.payload.data);
			state.isSuccess = true;
		},
		[postNewUtility.rejected]: (state, action) => {
			state.isLodaing = false;
			state.isError = true;
			state.massage = action.payload;
		},

		//Delete  UTILITY
		[DeleteUtility.pending]: (state) => {
			state.isLodaing = true;
		},
		[DeleteUtility.fulfilled]: (state, action) => {
			state.isLodaing = false;
			state.utility.data.data = state.utility.data.data.filter(
				(el) => el.id !== action.payload,
			);
			state.isSuccess = true;
		},
		[DeleteUtility.rejected]: (state, action) => {
			state.isLodaing = false;
			state.isError = true;
			state.massage = action.payload;
		},

		//EDIT NEW UTILITY
		[editUtility.pending]: (state) => {
			state.isLodaing = true;
		},
		[editUtility.fulfilled]: (state, action) => {
			state.isLodaing = false;
			// state.utility.data.data.map((item) => {
			//   if (item.id === action.payload.data.id) {
			//     item.title = action.payload.data.title;
			//     item.state_id = action.payload.data.state_id;
			//     item.rate = action.payload.data.rate;
			//     item.discounted_rate = action.payload.data.discounted_rate;
			//     item.meter_rate = action.payload.data.meter_rate;
			//     item.rebates = action.payload.data.rebates;
			//     item.annual_increase_percentage =
			//       action.payload.data.annual_increase_percentage;
			//     item.utility_provider_id = action.payload.data.utility_provider_id;
			//   }
			// });

			state.isSingleSuccess = true;
			toast.success(' Utility Updated  sucessfully ');
		},
		// [editUtility.fulfilled]: (state, action) => {
		//   state.isLodaing = false;
		//   state.isError = action.payload;
		//   state.isSuccess = true;
		// },
		[editUtility.rejected]: (state, action) => {
			state.isLodaing = false;
			state.isError = true;
			state.massage = action.payload;
		},

		//get single NEW UTILITY
		[getSingleUtility.pending]: (state) => {
			state.isSingleLodaing = true;
		},
		[getSingleUtility.fulfilled]: (state, action) => {
			state.isSingleLodaing = false;
			state.singleUtility = action.payload;
			state.isSuccess = true;
		},
		[getSingleUtility.rejected]: (state, action) => {
			state.isSingleLodaing = false;
			state.isError = true;
			state.massage = action.payload;
		},
	},
});
export const { reset, utilitySearchAction } = utilitySLice.actions;
export default utilitySLice.reducer;
